/**
 * Thread smoke — Casa Aura (Variant B)
 *
 * Thin gradient strokes rise and drift — wispy and thread-like.
 * Each particle draws a tapered line from its current position upward,
 * many overlapping near the column create the characteristic thread appearance.
 */
(function (root) {
  'use strict';
  if (root.SmokeCartoon) return;

  function Thread(ox, oy) {
    this.reset(ox, oy);
  }

  Thread.prototype.reset = function (ox, oy) {
    this.x    = ox + (Math.random() - 0.5) * 5;
    this.y    = oy;
    this.vx   = (Math.random() - 0.5) * 0.20;
    this.vy   = -(Math.random() * 0.50 + 0.40);
    this.len  = Math.random() * 40 + 35; // 35-75px — long enough to read as wisps
    this.w    = Math.random() * 1.4 + 1.0; // stroke width px
    this.life    = 0;
    this.maxLife = Math.floor(Math.random() * 220 + 200);
    this.turbOffset = Math.random() * 1000;
    this.alpha = 0;
    this.maxAlpha = 0.40 + Math.random() * 0.28;
    this.drift = (Math.random() - 0.5) * 0.3;
    // Random curve factor — gives each wisp its organic arc independent of velocity
    this.curveX = (Math.random() - 0.5) * 35;
  };

  Thread.prototype.update = function (t, ox, oy) {
    this.life++;
    if (this.life >= this.maxLife) { this.reset(ox, oy); return; }

    var progress = this.life / this.maxLife;
    var rise = Math.max(0, (oy - this.y) / (oy * 1.05));
    var turb = 0.15 + rise * 0.6;

    // Turbulence kicks in as thread rises
    this.vx += Math.sin(t * 0.020 + this.turbOffset) * 0.018 * turb;
    this.vx += this.drift * 0.002;
    this.vx *= 0.968;

    this.x  += this.vx;
    this.y  += this.vy;
    this.vy *= 0.999;

    // Thread length tapers near top
    this.len = (Math.random() * 40 + 35) * (1 - rise * 0.45);

    // Opacity
    if (progress < 0.08) {
      this.alpha = this.maxAlpha * (progress / 0.08);
    } else if (progress < 0.72) {
      this.alpha = this.maxAlpha;
    } else {
      this.alpha = this.maxAlpha * (1 - (progress - 0.72) / 0.28);
    }
  };

  Thread.prototype.draw = function (ctx) {
    if (this.alpha < 0.01) return;
    ctx.save();

    // Quadratic bezier — each wisp curves organically via curveX
    var endX = this.x + this.vx * 8 + this.curveX * 0.35;
    var endY = this.y - this.len;
    var cpX  = this.x + this.curveX; // control point pulls mid-stroke sideways
    var cpY  = this.y - this.len * 0.55;

    // Gradient along the stroke length
    var grad = ctx.createLinearGradient(this.x, this.y, endX, endY);
    var col = 'rgba(78,80,86,';
    grad.addColorStop(0,    col + this.alpha.toFixed(3) + ')');
    grad.addColorStop(0.6,  col + (this.alpha * 0.55).toFixed(3) + ')');
    grad.addColorStop(1,    col + '0)');

    ctx.strokeStyle = grad;
    ctx.lineWidth   = this.w;
    ctx.lineCap     = 'round';
    ctx.lineJoin    = 'round';
    ctx.beginPath();
    ctx.moveTo(this.x, this.y);
    ctx.quadraticCurveTo(cpX, cpY, endX, endY);
    ctx.stroke();
    ctx.restore();
  };

  function SmokeCartoon(canvas, opts) {
    this.canvas  = canvas;
    this.ctx     = canvas.getContext('2d');
    this.opts    = Object.assign({ autoplay: true, showEmber: true }, opts || {});
    this.threads = [];
    this.time    = 0;
    this.running = false;
    this._raf    = null;
    this._frame  = 0;

    this._resize = this._resize.bind(this);
    this._tick   = this._tick.bind(this);
    window.addEventListener('resize', this._resize);
    this._resize();

    // Pre-seed staggered threads
    for (var i = 0; i < 28; i++) {
      var th = new Thread(this.ox, this.oy);
      th.life = Math.floor(Math.random() * th.maxLife);
      this.threads.push(th);
    }

    if (this.opts.autoplay) this._setupIO();
  }

  SmokeCartoon.prototype._resize = function () {
    var parent = this.canvas.parentElement;
    this.canvas.width  = parent.offsetWidth;
    this.canvas.height = parseInt(this.canvas.dataset.height, 10) || 400;
    this.ox = this.canvas.width  / 2;
    this.oy = this.canvas.height * 0.92;
  };

  SmokeCartoon.prototype._setupIO = function () {
    var self = this;
    new IntersectionObserver(function (e) {
      e.forEach(function (en) { en.isIntersecting ? self.start() : self.stop(); });
    }, { threshold: 0.05 }).observe(this.canvas);
  };

  SmokeCartoon.prototype.start = function () {
    if (this.running) return;
    this.running = true;
    this._raf = requestAnimationFrame(this._tick);
  };

  SmokeCartoon.prototype.stop = function () {
    this.running = false;
    if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
  };

  SmokeCartoon.prototype._tick = function () {
    if (!this.running) return;
    this.time++;
    this._frame++;

    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Spawn new thread every 4 frames up to 38 total
    if (this._frame % 4 === 0 && this.threads.length < 38) {
      this.threads.push(new Thread(this.ox, this.oy));
    }

    // Ember
    if (this.opts.showEmber) {
      var g = ctx.createRadialGradient(this.ox, this.oy, 0, this.ox, this.oy, 10);
      g.addColorStop(0, 'rgba(255,200,90,0.14)');
      g.addColorStop(1, 'rgba(130,35,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(this.ox, this.oy, 10, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = 'rgba(255,230,160,0.45)';
      ctx.beginPath();
      ctx.arc(this.ox, this.oy, 1, 0, Math.PI * 2);
      ctx.fill();
    }

    for (var i = 0; i < this.threads.length; i++) {
      this.threads[i].update(this.time, this.ox, this.oy);
      this.threads[i].draw(ctx);
    }

    this._raf = requestAnimationFrame(this._tick);
  };

  root.SmokeCartoon = SmokeCartoon;
}(window));
